import _construct from "@babel/runtime/helpers/construct";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useManualTrigger
 */
import { useCallback } from 'react';
import { Trigger } from '@tencent/glue-model-popper';
import { usePopperInstance } from '../context/Popper';
import { useTrigger } from './useTrigger';
export function useManualTrigger(options) {
  var captureOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var triggerId = arguments.length > 2 ? arguments[2] : undefined;

  var _useTrigger = useTrigger(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _construct(Trigger, args);
  }, options, captureOptions, 'manual', triggerId),
      _useTrigger2 = _slicedToArray(_useTrigger, 3),
      triggerRef = _useTrigger2[0],
      trigger = _useTrigger2[1],
      show = _useTrigger2[2];

  var popper = usePopperInstance();
  var onShow = useCallback(function () {
    return popper.showPopper(trigger.getId());
  }, []);
  var onHide = useCallback(function () {
    return popper.hidePopper(trigger.getId());
  }, []);
  return [triggerRef, {
    trigger: trigger,
    onHide: onHide,
    onShow: onShow,
    show: show
  }];
}